import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { TranslateService } from "@ngx-translate/core";
import { OrderStateRenderer } from "./OrderStateRenderer";

export class OrderStateSCHelper {
  private renderer: OrderStateRenderer;
  constructor(protected orderStateColumn: string, protected translator: TranslateService) {
    this.renderer = new OrderStateRenderer(this.translator);
  }
  //PLEASE REVISE FOR SCRATCHPAD STATES NEEDED
  public getState(params: any): string {
    let orderState: CubiqTS.OrderState = params.data[this.orderStateColumn];
    let lockType: CubiqTS.LockType = params.data["lockType"];

    switch (orderState) {
      case CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED:
        return this.translator.instant(
          `order.state.${CubiqTS.OrderState[CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED]}`,
        );
      case CubiqTS.OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED:
        return CubiqTS.LockType.MODIFY_LOCK === lockType
          ? this.translator.instant(
              `order.state.${
                CubiqTS.OrderState[CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED]
              }.lock.type.${CubiqTS.LockType[CubiqTS.LockType.MODIFY_LOCK]}`,
            )
          : this.translator.instant(
              `order.state.${
                CubiqTS.OrderState[CubiqTS.OrderState.EXT_ACCEPTANCE_NEEDED]
              }.lock.type.none`,
            );
      default:
        return this.renderer.getStateAsString(orderState, lockType);
    }

    return "";
  }
}
